/**
 * Image Gallery block slider.
 *
 * Flickity is bundled from npm (see package.json) and used via the vanilla
 * `new Flickity()` API — no jQuery plugin. This file is bundled by Vite through
 * assets/js/entries/image-gallery.entry.js and enqueued from assets/build.
 *
 * Runs on the front end for every rendered block, and re-inits inside the
 * Gutenberg editor whenever ACF renders the block preview.
 */
import Flickity from 'flickity'
import 'flickity/css/flickity.css'

// Flickity measures the viewport once at init and only re-measures on window
// resize. Loaded as an ES module (and, in the editor, rendered into a preview
// that settles after mount) the first measurement can happen before layout is
// final, leaving the cell stuck flush-left. Force reflows after layout settles.
function reflow( flkty ) {
	requestAnimationFrame( () => flkty.resize() )
	setTimeout( () => flkty.resize(), 200 ) // editor: preview container settles after render
	window.addEventListener( 'load', () => flkty.resize() )
	if ( document.fonts && document.fonts.ready ) document.fonts.ready.then( () => flkty.resize() )
}

function initGallery( gallery ) {
	if ( ! gallery || gallery.flickityInited ) return
	gallery.flickityInited = true
	const flkty = new Flickity( gallery, {
		freeScroll: true,
		freeScrollFriction: 0.03, // lower friction, slides easier
		wrapAround: true,
		contain: true,
		prevNextButtons: true,
		pageDots: true,
		cellAlign: 'center',
		dragThreshold: 10,
	} )
	reflow( flkty )
}

function initAll( root ) {
	const scope = root && root.querySelectorAll ? root : document
	scope.querySelectorAll( '.wu_image-gallery .image-gallery' ).forEach( initGallery )
}

if ( document.readyState !== 'loading' ) {
	initAll()
} else {
	document.addEventListener( 'DOMContentLoaded', () => initAll() )
}

// Dynamic block preview in the editor. ACF passes the block as a jQuery object.
if ( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=image-gallery', ( $block ) => {
		const root = $block && $block[0] ? $block[0] : $block
		initAll( root )
	} )
}
